var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MonthSelector',{on:{"select":_vm.load}}),_c('List',{attrs:{"bizs":_vm.bizs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }